// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"dc40576e","488":"b507d18e","732":"daf741bd","977":"0dd4bb63"}[chunkId] + ".chunk.js");